import * as React from 'react';
import { IMarkerSection } from 'store/StateInterfaces';

import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { toTime } from 'Utils/common';

interface IMarkerEditProps {
  marker: IMarkerSection;
  cancelCallback: any;
}

interface IMarkerEditState {

}

export default class MarkerEdit extends React.Component<IMarkerEditProps, IMarkerEditState> {
  constructor(props: IMarkerEditProps) {
    super(props);

    this.state = {
    }
  }

  handleCancel = () => {
    this.props.cancelCallback();
  }

  handleSave = (event) => {
    const form = event.currentTarget;
    console.log(form);
    event.preventDefault();
    event.stopPropagation();
  }


  public render() {
    return (
      <Container style={{ background: 'white' }}>
        <div style={{ textAlign: "center" }}>
          <h4>Edit Section</h4>
        </div>
        <Form onSubmit={this.handleSave}>
          <Form.Row>
            <Form.Group as={Col} md='4' controlId='time'>
              <Form.Control
                required
                type='time'
                disabled
                value={`${toTime(this.props.marker.time)}`}
              />
            </Form.Group>
            <Form.Group as={Col} md='8' controlId='title'>
              <Form.Control
                required
                type='text'
                defaultValue={this.props.marker.title}
                placeholder='Section Title'
              />
            </Form.Group>
          </Form.Row>
          <Row>
            <Col md={2}>
              <Button style={{ border: '1px solid grey', width: '100%' }} variant='light' onClick={this.handleCancel}>
                Delete
              </Button>
            </Col>

            <Col md={{ span: 2, offset: 8 }}>
              <Button style={{ width: '100%' }} type='submit'>
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      </Container >
    );
  }
}

